import Content from './components/Content'
import Hero from './components/Hero'

const WorldOfTe = () => {
  return (
    <div>
        <Hero />
        <Content/>
    </div>
  )
}

export default WorldOfTe